import { deepCopy } from "../../../../utils/deepCopy";
import { toast } from "../../../../utils/messageUtils";

export const fetchManagerHeatmapQuestionsStarted = (state) => {
    return {
        ...state,
        managerHeatmapQuestionsApi: {
            isProcessing: true,
            error: false
        }
    }

}

export const fetchManagerHeatmapQuestionsSuccess = (state, payload) => {
    let topicQuestions = [];
    let heatmapData = deepCopy(state.managerHeatmapData);
    if (payload.data && payload.data.data) {
        topicQuestions = payload.data.data.dataMap
    }
    if (topicQuestions.length) {
        heatmapData = addTopicQuestionsToTopic({ heatmapData, topicQuestions }, payload.dimension)
    }
    return {
        ...state,
        managerHeatmapQuestionsApi: {
            isProcessing: false,
            error: false
        },
        managerHeatmapData: heatmapData
    }

}

export const fetchManagerHeatmapQuestionsFailed = (state, payload) => {
    toast.error("Failed to fetch questions data.")
    return {
        ...state,
        managerHeatmapQuestionsApi: {
            isProcessing: false,
            error: true
        },
        isDataFetchedManager: false
    }

}

const addTopicQuestionsToTopic = ({ heatmapData, topicQuestions }, dimension) => {
    const data = heatmapData;
    data.forEach(item => {
        if (item.name === dimension) {
            item.children = topicQuestions
        }
    })
    return data
}